import type { FC, PropsWithChildren } from 'react';
import { createContext, useContext, useMemo } from 'react';

import { useRessource } from 'app/utils/ressource';
import UserContext from 'app/common/UserContext';

import { creatGlobalDataRequest, handeGlobalMessage } from './resources';
import type { GlobalContextValue } from './types';

const defaultValues: GlobalContextValue = {
  outrightsSeriesOpenRemindersCount: 0
};

const GlobalContext = createContext(defaultValues);

const GlobalProvider: FC<PropsWithChildren> = ({ children }) => {
  const { userType } = useContext(UserContext);
  const firstGlobalRequest = useMemo(() => creatGlobalDataRequest(userType), []);

  const { data } = useRessource({
    fetchInitialData: firstGlobalRequest,
    topics: userType === 'pandascore' ? [{ topic: 'global' }] : [],
    handleMessage: handeGlobalMessage
  });

  const values: GlobalContextValue = useMemo(() => {
    if (data) {
      return data;
    }
    return defaultValues;
  }, [data]);

  return <GlobalContext.Provider value={values}>{children}</GlobalContext.Provider>;
};

GlobalContext.displayName = 'GlobalContext';

export default GlobalContext;
export { GlobalProvider };
